import { getComponentFromName } from '@folklore/utils';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';

import useAuthors from '../../hooks/useAuthors';

import * as CardComponents from '../cards/authors';
import PresentationList, { PresentationListProps } from './PresentationList';

const hooks = {
    default: useAuthors,
};

export interface AuthorsListProps extends Omit<
    PresentationListProps<Author>,
    'cardComponent' | 'hook'
> {
    hook?: string | null;
    cardComponent?: ElementType | null;
    cardType?: string | null;
}

function AuthorsList({ hook = 'default', cardType, cardComponent, ...props }: AuthorsListProps) {
    return (
        <PresentationList<Author>
            hook={isString(hook) ? hooks[hook] || hooks.default : hook}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, CardComponents.Vertical)
            }
        />
    );
}

export default AuthorsList;
